import { Injectable } from '@angular/core';

@Injectable()
export class ImageConverterProvider {
	private video = [
		'webm',
		'mkv',
		'avi',
		'wmv',
		'mp4',
		'amv',
		'3gp',
		'mpeg',
		'mov'
	];
	private text = ['doc', 'docx', 'odt', 'rtf', 'dot'];
	private pdf = ['pdf'];
	private database = ['db', 'sql', 'accdb', 'accde', 'accdt', 'accdr', 'mdw'];
	private presentation = ['ppt', 'pptx', 'pps', 'odp'];
	private excel = ['ods', 'xls', 'xlsx', 'xlw', 'xlt', 'xlsb', 'xlsm', 'ods'];
	private music = ['midi', 'ogg', 'wav', 'mp3', 'wma'];
	private archive = ['7z', 'apk', 'jar', 'rar', 'tar', 'gz', 'zip', 'tar'];
	private image = [
		'jpeg',
		'jpg',
		'gif',
		'bmp',
		'tiff',
		'nef',
		'png',
		'raw',
		'svg'
	];
	private photoshop = ['psd'];
	private illustrator = ['ai'];

	private fileExtensions: any = {
		video: this.video,
		text: this.text,
		pdf: this.pdf,
		database: this.database,
		presentation: this.presentation,
		excel: this.excel,
		music: this.music,
		archive: this.archive,
		image: this.image,
		photoshop: this.photoshop,
		illustrator: this.illustrator
	};

	constructor() {}

	private getFileExtension(fileName: string): string {
		return /[.]/.exec(fileName) ? /[^.]+$/.exec(fileName)[0] : 'undefined';
	}

	getFileClass(fileName: string): string {
		const DEFAULT_TYPE = 'default-type';
		const extension = this.getFileExtension(fileName);

		for (const key of Object.keys(this.fileExtensions)) {
			const fileExtensionType = this.fileExtensions[key];
			const foundExtension = fileExtensionType.find(
				item => item.toLowerCase() === extension.toLowerCase()
			);

			if (foundExtension) {
				return key;
			}
		}
		return DEFAULT_TYPE;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/files/image-converter.service.ts